<template>
  <el-dialog
    :title="$t('SeaExport.AddSpellCustomsOrderNo')"
    :visible.sync="innerVisible"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="400px"
  >
    <el-form>
      <el-form-item :label="$t('SeaExport.PleaseForAddingAndForm')" required>
        <el-select v-model="config.ruleType" clearable :disabled="finalRuleTypes.length<=1">
          <el-option v-for="type in finalRuleTypes" :key="type.code" :value="type.code" :label="type.chineseName" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('SeaExport.PleaseSelectSuffixSeparator')">
        <el-select v-model="config['split']" clearable :disabled="inputMbl===2 || inputMbl===3">
          <el-option v-for="(char,index) in splitChars" :key="index" :value="char" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('SeaExport.PleaseCustomsDeclarationNoSpelled')" required>
        <el-input-number v-model="config.generateCount" :min="0" :step="1" step-strictly style="width: 100%;" :controls="false" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" @click="handleConfirm">{{ $t('Message.Confirm') }}</el-button>
      <el-button @click="innerVisible = false">{{ $t('Message.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { generateSoNo } from '@/api/seaExport/mbl'
import { CHILD_NO_EXTENSION, SO_NO_RULE_TYPES, SPILT_CHARS } from '@/class/cargo/model/parameters/SeaExportConstants.js'
import { getOfficeConfigByName } from '@/api/user'

export default {
  name: 'GenerateSoNoDialog',
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    form: {
      type: Object,
      default: () => ({})
    },
    config: {
      type: Object,
      default: () => ({})
    },
    inputMbl: { type: Number, default: 0 }, // 2 太平模式
    mblConfig: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      ruleTypes: SO_NO_RULE_TYPES,
      splitChars: SPILT_CHARS,
      finalRuleTypes: []
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close')
        } else {
          this.$emit('open')
        }
      }
    }
  },
  watch: {
    async visible(val) {
      if (val) {
        this.resetConfig()
        let curRule = null
        console.log(this.form)
        console.log(this.mblConfig.curRule)
        if (this.form.mblConfigName && (!this.mblConfig.curRule || this.mblConfig.curRule.name != this.form.mblConfigName)) {
          const res = await getOfficeConfigByName({
            officeId: this.$store.getters.currentOfficeId,
            configName: 'SEMblNoPattern'
          })
          curRule = res.data.details.find(item => item.name === this.form.mblConfigName)
        } else {
          curRule = this.mblConfig.curRule
        }
        const arr = Array.from(this.ruleTypes)
        this.finalRuleTypes = curRule ? arr.filter(type => curRule[type.code]) : arr
        if (this.finalRuleTypes.length === 1) {
          this.config.ruleType = this.finalRuleTypes[0].code
        }
        if (this.inputMbl === 2 || this.inputMbl === 3) {
          // 太平模式下，默认主单号顺延
          this.config.ruleType = CHILD_NO_EXTENSION.code
        }
      }
    }
  },
  methods: {
    handleConfirm() {
      const { ruleType, split, generateCount } = this.config
      if (!ruleType) {
        this.$message.error(this.$t('SeaExport.PleaseForAddingAndForm'))
        return
      }
      if (!generateCount) {
        this.$message.error(this.$t('SeaExport.PleaseCustomsDeclarationNoSpelled'))
        return
      }
      console.log(this.form.soNo)
      const params = {
        mbl: this.form.mbl,
        soNo: String(this.form.soNo).replace(/\n/g, ','),
        ruleType, split, generateCount
      }
      generateSoNo(params).then(res => {
        const { data } = res
        const soNoArray = data.split(',')
        if (soNoArray.length === 1 && !soNoArray[0]) {
          this.$message.warning(this.$t('SeaExport.CycleTwoHundredTimesNotUseMbl'))
          return
        }
        if (generateCount > soNoArray.length) {
          this.$message.warning(this.$t('SeaExport.GenerateMblButLessThan', [soNoArray.length]))
        }
        this.form.soNo = this.form.soNo + '\n' + data.replace(/,/g, '\n')
        this.resetConfig()
        this.$emit('close')
      })
    },
    resetConfig() {
      this.config.ruleType = ''
      this.config.split = ''
      this.config.generateCount = ''
    }
  }
}
</script>

<style scoped>

</style>
